import React from 'react'
import { HubCompanyEcosystemManagement } from 'domain/feature/hub/company/Ecosystem'
import { cookies } from 'sharedKernel/cookies/behavior'
import { GetFormat, useGet } from 'sharedKernel/api'

export const HubCompanyEcosystemPage = (): JSX.Element => {
  return (
    <HubCompanyEcosystemManagement />
  )
}
